<template>
  <div class="ExpenseCategoryCard card">
    <div class="card__section">
      <ExpandableDetail>
        <template v-slot:summary>
          <h5 class="org-name text-blue text-upper text-small">
            <span class="text-small">{{ expenseCategory.name }}</span>
          </h5>

          <div
            class="ExpenseCategoryCard__EmbeddedHeading with high specificity"
            v-html="expenseCategory.descriptionHtml"
          />
        </template>

        <template v-slot:detail>
          <div class="card__section card__section--bordered">
            <p class="text-small text-upper">Documentation Description HTML</p>
            <div
              class="ExpenseCategoryCard__EmbeddedContent with high specificity"
              v-html="expenseCategory.documentationDescHtml"
            />
          </div>
        </template>
      </ExpandableDetail>
    </div>
  </div>
</template>

<script>
import ExpandableDetail from '@/components/ExpandableDetail'

export default {
  name: 'ExpenseCategoryCard',
  components: {
    ExpandableDetail,
  },
  props: {
    expenseCategory: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../styles/variables';
@import '../../styles/mixins/cards';

.card {
  @include card;
}

.ExpenseCategoryCard {
  margin-bottom: 24px;
}

.ExpenseCategoryCard__EmbeddedContent {
  padding: 12px;
  border: 1px solid lightgray;
  border-radius: 8px;
  background-color: #f5f5f5;
}
</style>

<style>
.ExpenseCategoryCard__EmbeddedHeading.with.high.specificity *,
.ExpenseCategoryCard__EmbeddedContent.with.high.specificity * {
  margin: 0;
  padding: 0;
}

.ExpenseCategoryCard__EmbeddedContent.with.high.specificity ul > li {
  margin-left: 22px;
}
</style>
